import React, { useState, useEffect } from 'react';
import verifyToken from './HelperFx/verifyJwt';
import { BrowserRouter, Routes, Route, Navigate  } from 'react-router-dom';
import SignIn from './Routing/SignIn';
import Error from './Routing/Error';
import OtpLogin from './Routing/OTPlogin';
import ChangePassword from './Routing/ResetPasswordOnFirstLogin';
import privateRoutes from './Data/Routers';
import ProtectedRoutes from './Routing/ProtectedRoutes';
import Index from './Routing/Index';
import axios from 'axios';
import { Buffer } from 'buffer';
import SignUp from './Routing/Signup';
import ResetPwd from './Routing/ResetPwd';


const REACT_EXPRESS = process.env.REACT_APP_EXPRESS_SERVER;

const BackendUname =process.env.REACT_APP_BACKEND_API_USERNAME;
const BackendPwd =process.env.REACT_APP_BACKEND_API_PASSWORD;


const App = () => {
  const [isAuthenticated, setIsAuthenticated] = useState(false);
  const [loading, setLoading] = useState(true);

  const token = Buffer.from(`${BackendUname}:${BackendPwd}`).toString('base64');
  

  

  useEffect(() => {
    const checkAuth = async () => {
      const tokenCode = sessionStorage.getItem('authToken');
      
      if (tokenCode) {
        try {
          const validToken = verifyToken(tokenCode);
          setIsAuthenticated(Boolean(validToken?.userName));
        } catch (error) {
          setIsAuthenticated(false);
        }
      } else {
        setIsAuthenticated(false);
      }

      setLoading(false);
    };

    checkAuth();

    const handleTokenUpdate = () => {
      console.log('Token updated event received');
      checkAuth();
    };

    window.addEventListener('tokenUpdated', handleTokenUpdate);
    return () => window.removeEventListener('tokenUpdated', handleTokenUpdate);
  }, []);

  useEffect(() => {
    if (!isAuthenticated) return;

    let inactivityTimeout;
    const jwttoken = sessionStorage.getItem('authToken');
    const { userName } = verifyToken(jwttoken) || {};

    const logoutUser = async () => {
      try {
        if (userName) {
          await axios.patch(
            `${REACT_EXPRESS}/logout/${encodeURIComponent(userName)}`,
            null,
            {
              headers: {
                'Authorization': `Basic ${token}`,
              },
              validateStatus: () => true,
            }
          );
        }
      } catch (_error) {
        // Session is still cleared locally even if the API is unavailable.
      } finally {
        localStorage.removeItem('authToken');
        sessionStorage.removeItem('authToken');
        sessionStorage.removeItem('isAdmin');
        sessionStorage.removeItem('reloaded');
        setIsAuthenticated(false);
        window.location.href = '/signin';
      }
    };

    const resetInactivityTimer = () => {
      clearTimeout(inactivityTimeout);
      inactivityTimeout = setTimeout(logoutUser, 20 * 60 * 1000); // 20 mins
    };

    const activityEvents = ['mousemove', 'keydown', 'click', 'scroll', 'touchstart'];

    activityEvents.forEach(event => {
      window.addEventListener(event, resetInactivityTimer);
    });

    resetInactivityTimer(); // Start timer initially

    return () => {
      clearTimeout(inactivityTimeout);
      activityEvents.forEach(event => {
        window.removeEventListener(event, resetInactivityTimer);
      });
    };
  }, [isAuthenticated]);

  if (loading) {
    return <div>Loading...</div>;
  }

  return (
    <BrowserRouter>
      <Routes>
        <Route exact path="/" element={<Index />} />
        <Route exact path="/signin" element={<SignIn />} />
        <Route exact path="/signup" element={<SignUp />} />
        <Route exact path="/loginOtp" element={<OtpLogin />} />
        <Route exact path="/resetpwd" element={<ResetPwd />} />
        <Route exact path="/changepwd" element={<ChangePassword />} />
        {/* <Route exact path="/forgotpwd" element={<ForgotPwd />} /> */}

        {/* Protected routes */}
        {privateRoutes.map((route, index) => (
          <Route
            key={index}
            exact
            path={route.path}
            element={
              <ProtectedRoutes
                element={route.element}
                isAuthenticated={isAuthenticated}
                loading={loading}
              />
            }
          />
        ))}

        <Route exact path="*" element={<Error />} />
      </Routes>
    </BrowserRouter>
  );
};

export default App;